import React from 'react';
import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SelectorSection from './SelectorSection';

/**
 * Radio picker for who must complete Polyguard verification on a meeting
 * link: 'all' | 'external_only'. Shared by the link create/edit modals and
 * the per-app Defaults section. Styled to match the proof selector sections.
 */
export default function AuthRequiredForSelector({ value, onChange, disabled = false }) {
  const { t } = useTranslation('shared');

  const option = (val, title) => (
    <FormControlLabel
      value={val}
      sx={{ mr: 0 }}
      control={<Radio size="small" disabled={disabled} sx={{ py: 0.5 }} />}
      label={<Typography variant="body2">{title}</Typography>}
    />
  );

  return (
    <SelectorSection title={t('authSelector.label')} instruction={t('authSelector.instruction')}>
      <RadioGroup value={value} onChange={(event) => onChange(event.target.value)}>
        {option('all', t('authSelector.all'))}
        {option('external_only', t('authSelector.externalOnly'))}
      </RadioGroup>
    </SelectorSection>
  );
}
